import { useAppDispatch } from 'hooks/reduxHooks'
import {
  type unstable_AdapterOptions as AdapterOptions,
  unstable_createAdapterProvider as createAdapterProvider,
  renderQueryString
} from 'nuqs/adapters/custom'
import { useLocation } from 'react-router'
import { replace, push } from 'connected-react-router'

/**
 * Since nuqs doesn't support React Router 5, we have to implement our own adapter.
 * This is based on https://nuqs.dev/docs/community-adapters/onejs
 *
 * Unofficial nuqs adapters currently must rely on unstable APIs. But since they've
 * published a few community-contributed adapters in the nuqs docs, hopefully they
 * won't make too many breaking changes. Nevertheless if we update nuqs we'll need
 * to check that our adapter hasn't broken.
 *
 * The more complete solution would be to update to a newer version of React Router.
 */
function useReactRouter5Adapter() {
  const location = useLocation()
  const dispatch = useAppDispatch()

  const updateUrl = (search: URLSearchParams, options: AdapterOptions) => {
    if (options.history === 'push') {
      dispatch(push({ ...location, search: renderQueryString(search) }))
    } else {
      dispatch(replace({ ...location, search: renderQueryString(search) }))
    }
  }
  return {
    searchParams: new URLSearchParams(location.search),
    updateUrl,
  }
}

export const NuqsAdapter = createAdapterProvider(useReactRouter5Adapter)
